import * as v from 'valibot';

export enum SequencingModel {
  DEVICE_SPECIFIC = 'device-specific', // aka ARPI
  DEVICE_SPECIFIC_EPC = 'device-specific-epc',
  SECTION_SPECIFIC = 'section-specific',
  SECTION_SPECIFIC_V2 = 'section-specific-v2',
  GEO_SECTION_SPECIFIC = 'geo-section-specific',
  WP_DEFAULT = 'wp-default',
  ACXIOM = 'acxiom',
}

export const SequencingModelSchema = v.enum(SequencingModel);
